import {h, Fragment} from "preact"
import { useFacet } from '@nosto/preact'

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet);

    return (
        <details class="facets__disclosure-vertical js-filter">
            <summary 
                class="facets__summary facets__text focus-offset" 
                aria-label={`${facet.name} (${selectedFiltersCount} selectionado)`}
                aria-expanded={active}
                aria-controls={`ns-serp-${facet.id}-facet`}
                role="button"
                onClick={toggleActive}
            >
                <div>
                    <span>
                        {facet.name}
                        <span class="facets__selected no-js-hidden hidden">
                            ({selectedFiltersCount})
                        </span>
                    </span>
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                    </svg>
                </div>
            </summary>

            <div 
                id={`ns-serp-${facet.id}-facet`}
                class="parent-display facets__display-vertical"
            >
                <fieldset class="facets-wrap parent-wrap facets-wrap-vertical">
                    <legend class="visually-hidden">{facet.name}</legend>
                    <ul class="list-unstyled no-js-hidden" role="list">
                        {facet.data?.map(value => (
                            <li key={value.value} class="list-menu__item facets__item">
                                <label class="facet-checkbox facets__text">
                                    <input
                                        type="checkbox"
                                        id={`ns-filter-${facet.field.toLowerCase().replaceAll(' ', '-')}-${value.value.toLowerCase().replaceAll(' ', '-')}`}
                                        checked={value.selected}
                                        value={value.value}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            toggleProductFilter(facet.field, value.value, !value.selected)
                                        }}
                                    />
                                    <div class="icon icon-checkbox-off" style=" width: 16px; height: 16px; padding: 1px;">
                                        <div style="display: block; width: 14px; height: 14px; border-radius: 1px; border: 1.69px solid #D2D2D7;" />
                                    </div>
                                    <svg class="icon icon-checkbox-on" width="17" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
                                        <rect x="1.865" y="1.365" width="13.27" height="13.27" rx=".427" fill="#0071E3" stroke="#0071E3" stroke-width=".73"></rect><path d="M7.417 11.994c-.14 0-.262-.067-.367-.2L4.605 8.78a.656.656 0 0 1-.081-.129.395.395 0 0 1-.024-.133c0-.095.032-.175.095-.238.067-.067.15-.1.248-.1.118 0 .221.058.31.176l2.25 2.808 4.438-6.989a.4.4 0 0 1 .129-.133.322.322 0 0 1 .176-.043c.095 0 .173.03.234.09.06.061.09.14.09.239a.405.405 0 0 1-.019.12.6.6 0 0 1-.067.137L7.77 11.8a.409.409 0 0 1-.353.195Z" fill="#fff"></path>
                                    </svg>
                                    <span aria-hidden="true">
                                        {value.value}{' '}<span class="filter-count">({value.count})</span>
                                    </span>
                                    <span className="visually-hidden">
                                        {value.value}{' '}<span className="filter-count">({value.count} productos)</span>
                                    </span>
                                </label>
                            </li>
                        ))}
                    </ul>
                </fieldset>
            </div>
        </details>
    )
}
